import React from 'react';
import '../styles/App.css';
import Stars from './Stars';
import Header from './Header';
import CustomerHappiness from './CustomerHappinessMetric';
import Metric from './Metric';
import Logo from './Logo';
import CertifiedByLiveChat from './CertifiedByLiveChat';
import ChatButton from './ChatButton';
import { translate } from 'react-polyglot';

const Quality = props => {
  const {
    t,
    happiness,
    name,
    score,
    total_ratings,
    first_response_time,
    are_agents_available,
    loading,
    url,
    chat_hidden
  } = props;

  return (
    <div className="app">
      <Logo {...props} />

      <Header
        title={
          happiness > 0
            ? t('quality_excellent_service')
            : t('quality_cs_quality')
        }
        lead={
          happiness > 0
            ? t('quality_percent_customers_happy_with_service', {
                clients_percent: `${happiness}%`,
                NAME: name ? name : url.replace(/^https?:\/\//, '')
              })
            : t('quality_not_enough_data_to_calculate')
        }
      />

      <Stars score={score} />

      <div className="metrics">
        <CustomerHappiness customer_satisfaction={happiness} />

        <Metric
          type="agents-available"
          number={total_ratings}
          description={`${t('quality_total')}`}
          bottom={t('quality_last_month_plular', { months: '12' })}
        />

        <Metric
          type="daily-availability"
          number={first_response_time === 's' ? '0s' : first_response_time}
          description={t('quality_replies_in')}
          bottom={t('quality_last_month')}
        />
      </div>

      {!chat_hidden &&
        <ChatButton agentsAvailable={are_agents_available} loading={loading} />}

      <CertifiedByLiveChat {...props} />
    </div>
  );
};
export default translate()(Quality);



// WEBPACK FOOTER //
// ./src/components/Quality.js